<div class="modal">
    <div class="modal-ctn">
  
      <div class="options">
        <div>{{ 'PARTICIPANT.NEW' | translate }}</div>
        <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
      </div>
  
      <form [formGroup]="form" class="form-grid">
        <div>
          <label>{{ 'PARTICIPANT.FIRST_NAME' | translate }}</label>
          <df-input block formControlName="firstName" />
        </div>
        <div>
          <label>{{ 'PARTICIPANT.LAST_NAME' | translate }}</label>
          <df-input block formControlName="lastName" />
        </div>
        <div>
          <label>{{ 'PARTICIPANT.EMAIL' | translate }}</label>
          <df-input block type="email" formControlName="email" />
        </div>
        <!-- <div>
          <label>{{ 'PARTICIPANT.FUNCTION' | translate }}</label>
          <select formControlName="role">
              <ng-container *ngFor="let f of refineryparticipantfunctions">
                  <option value="{{ f.refineryparticipantfunctionpk }}">{{ f.refineryparticipantfunction }}</option>ça j'en doute pas
              </ng-container>
          </select>
        </div>  -->
      </form>
  
      <div class="footer">
        <df-button (onClick)="close()">{{ 'CLOSE' | translate }}</df-button>
        <df-button variant="primary" (onClick)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate }}</df-button>
      </div>        
    </div>
  </div>